import Vue from 'vue';
import { docPages } from './DocPages';
import gpxPlanner from '@/DocGPXPlanner.vue';
import StorageHelper from './StorageHelper';

export default Vue.component('welcome-carousel', {
    components: {
        gpxPlanner
    },
    data: () => ({
        email: "",
        password: "",
        confirmpassword: "",
        userError: "",
        operation: 0,
        loading: false,
        snackbar: false,
        snackbarText: '',
        snackbarColor: '',
        dontShowAgain: false,
        helpPages: docPages,
        allowFunctionalCookies: StorageHelper.allowFunctionalCookies
    }),
    watch: {
        allowFunctionalCookies(newVal: boolean) {
            StorageHelper.allowFunctionalCookies = newVal
        }
    },
    methods: {
        showError: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = 'error'
        },
        showInfo: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = ''
        },
        allowStrictlyNecessaryCookiesAndClose: function (message: string | null) {
            this.allowFunctionalCookies = true;
            this.dontShowAgain = true;
            StorageHelper.allowFunctionalCookies = this.allowFunctionalCookies;
            StorageHelper.setItem("DontShowWelcome", this.dontShowAgain ? "true" : "false");
            this.$emit('close', message);
        }
    },
});
